import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "exchangeIQDToDollar",
})
export class ExchangeIQDToDollarPipe implements PipeTransform {
  transform(value: number, exchangeRate: number): number {
    if (value == null) return value;
    let result =
      value / (exchangeRate ?? +localStorage.getItem("exchangeRate"));
    return +result.toFixed(2);
  }
}
